import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Container, Form, Row, Col, Table, Tab } from 'react-bootstrap'
import { Link, useNavigate } from "react-router-dom";
import FeaturedProducts from '../FeaturedProducts';
import * as AuthVerify from '../../lib/common';
import { BASE_URL } from '../../lib/constant';
import Modal from 'react-bootstrap/Modal';
import * as Yup from "yup";
import { Formik } from "formik";
import { Flip, Slide, toast } from 'react-toastify';
import InputField from "../InputField/InputField";
import Moment from 'react-moment';
import Axios from '../../lib/axios/axiosInstance';
import CsvDownloadButton from 'react-json-to-csv'
import ReactToPrint,{useReactToPrint} from "react-to-print";
import DynamicProductList from "../DynamicProductList/FeaturedProductList";
import AlternativeProduct from '../ProductDetailRight/AlternativeProduct';
import Logo from "../../assets/images/logo.png";

const ShoppingCart = () => {
    const navigate = useNavigate();
    let componentRef = useRef();
    let fakeRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    
    const fileInputRef = useRef(null);
    const mockData = useRef([]);
    
    const downloadFile = () => {
        // Get Template
        // api/corporate/template/order
        Axios.get('/corporate/template/order')
        .then(result=>{
          if(result?.data?.data?.template){
            mockData.current=result?.data?.data?.template;
          }
        })
      };
    
      useEffect(()=>{
        downloadFile();
      },[])

      const addData = (newData) =>{
        
          var error="";
          newData.map((element,i) => {
            if(!element.seq){
              error+=`line ${i+2} seq missing | `+'\n'
            }
            if(!element.sku){
              error+=`line ${i+2} sku missing | `+'\n'
            }
            if(!element.qty){
              error+=`line ${i+2} qty missing | `+'\n'
            }
          });
          if(error.length>0){
            return toast.warning(error, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 30000,
              transition: Slide,
            });
          }
          else{
            const newMergedData = [
              ...newData
            ];
            saveChangesHandler(newMergedData);
          }
        // }
      }

      const saveChangesHandler =async (newMergedData) =>{
        const body = {items: newMergedData}
        // setIsLoading(true);
        // Insert Items
        // api/cart/import/:refnum
        await Axios.post(`/cart/import/${cartDetails.carth.refnum}`,body)
          .then(function (response) {
            if (response && response.data?.success) {
                setCartDetails(false);
                loadDetails();
                toast.success("Data imported successfully !", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                  });
            }
            else {
              toast.error("Data import failed !", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
              });
            }
          })
      }

    const handleFile = (file) => {
    if(file){
        AuthVerify.readFileAsJson(file,addData);
        fileInputRef.current.value=null;
    }else{
        toast.warning("Please select a CSV file first !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
        });
    }
    };

    const [cartDetails, setCartDetails] = useState(false);
    const [saveAsTemplateModal, setSaveAsTemplateModal] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [availableBudgets, setAvailableBudgets] = useState(false);
    const [loadBudgetData, setLoadBudgetData] = useState(false);
    const [selectedBudget, setSelectedBudget] = useState(false);
    const [interestedProducts, setInterestedProducts] = useState(false);
    const [promoCode, setPromoCode] = useState('');
    const promoCodeNew = useRef('');
    const [promoCodeApplied, setPromoCodeApplied] = useState(false);
    const [allowPartialCheckbox, setAllowPartialCheckbox] = useState(false);
    const [templateData, setTemplateData] = useState(false);
    const [showAdhocModal, setShowAdhocModal] = useState(false);

    async function updateCartItems(e, itemDetails, qty, direct = false, updateTemplate = false, templateData) {
        if (!updateTemplate)
            e.preventDefault();

        setCartDetails(false);
        if (!updateTemplate) {
            if (direct) {
                itemDetails.qty = parseInt(qty);
            } else {
                itemDetails.qty += qty;
            }
        }
        else {
            itemDetails.templatedata = templateData;
        }
        console.log(itemDetails);
        await AuthVerify.addTocart(itemDetails, { qty: itemDetails.qty }, true).then(function (result) {
            cartDetails.items = result.items;
            cartDetails.carth.totalamt = result.summary.totalamt;
            cartDetails.carth.shippingamt = result.summary.shippingamt;
            cartDetails.carth.gstamt = result.summary.gstamt;
            cartDetails.carth.grossamt = result.summary.subamt;
            cartDetails.carth.promocode = result.summary.promocode;
            cartDetails.carth.discamt = result.summary.discamt;
            setCartDetails(cartDetails);
            if(!result.summary.promocode)
            {
                setPromoCodeApplied(false);
                setPromoCode('');
            }
        });
    }
    async function deleteCartItems(e, itemDetails) {
        e.preventDefault();

        setCartDetails(false);
        await AuthVerify.deleteCartItems(itemDetails.uuid)
            .then(function (result) {
                cartDetails.items = result.items;
                cartDetails.carth.totalamt = result.summary.totalamt;
                cartDetails.carth.shippingamt = result.summary.shippingamt;
                cartDetails.carth.gstamt = result.summary.gstamt;
                cartDetails.carth.grossamt = result.summary.subamt;
                cartDetails.carth.promocode = result.summary.promocode;
                cartDetails.carth.discamt = result.summary.discamt;
                setCartDetails(cartDetails);
                if (!result.summary.promocode) {
                    setPromoCodeApplied(false);
                    setPromoCode('');
                }
            });
    }
    async function updateAdhocCartItem(itemDetails) {
        setCartDetails(false);

        var uuid = `AD-${Date.now()}`
        console.log(itemDetails);
        var data = {
            refnum: cartDetails?.carth?.refnum,
            seq: itemDetails.seq ?? 1,
            qty: itemDetails?.qty ?? 1,
            uprice: itemDetails?.uprice,
            uuid: uuid,
            matname: itemDetails?.matname,
            uom: itemDetails?.uom
        }
        console.log(data)
        const url = `/cart/adhocitem/${cartDetails?.carth?.refnum}`;
        await Axios.post(url, data)
            .then(function (result) {
                cartDetails.items = result.data.items;
                cartDetails.carth.totalamt = result.data.summary.totalamt;
                cartDetails.carth.shippingamt = result.data.summary.shippingamt;
                cartDetails.carth.gstamt = result.data.summary.gstamt;
                cartDetails.carth.grossamt = result.data.summary.subamt;
                cartDetails.carth.promocode = result.data.summary.promocode;
                cartDetails.carth.discamt = result.data.summary.discamt;
                setCartDetails(cartDetails);
                if (!result.data.summary.promocode) {
                    setPromoCodeApplied(false);
                    setPromoCode('');
                }
                toast.success('Item added successfully.', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            });
    }
    async function saveAsDraft(e) {
        e.preventDefault();

        // setCartDetails(false);

        await AuthVerify.saveAsDraft().then(result => {
            if (result) {
                setCartDetails(false);
                AuthVerify.getCartRef(true);
            }
        });
    }

    const saveAsTemplate = async (values) => {
        if (!cartDetails?.carth?.refnum) window.location.href = '/';
        var body = {
            "template": {
                "templatename": values.templateName,
                "remark": values.templateRemarks
            }
        }

        // Save As Template
        // api/cart/savetemplate/:refnum
        await Axios.post(`/cart/savetemplate/${cartDetails?.carth?.refnum}`, body)
            .then(function (response) {
                if (response && response.data?.data?.template) {
                    setSaveAsTemplateModal(false);
                    toast.success("Successfully saved as template.", {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                }
                else {
                    toast.error(response.statusText, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                    setSaveAsTemplateModal(false);
                    return false;
                }
            })
            .catch(function (error) {
                setSaveAsTemplateModal(false);
                return false;
            });
    }

    const getYouMayInterestedProducts = async () => {
        var user = AuthVerify.getUser();
        if (!user) window.location.href = '/';
        setUserDetails(user);
        // Get Suggested product
        // api/cart/interested/:refnum
        await Axios.get(`/cart/interested/${user.refnum}`)
            .then(function (response) {
                if (response && response.data?.data?.items) {
                    setInterestedProducts(response.data?.data.items);
                }
                else {
                    setInterestedProducts([]);
                    return false;
                }
            })
            .catch(function (error) {
                setInterestedProducts([]);
                return false;
            });
    }

    const getAvailableBudgets = async () => {
        var user = AuthVerify.getUser();
        if (!user) window.location.href = '/';
        setUserDetails(user);
        // Get Budgets available for a cart
        // https://devb2b.bizpoint-intl.com:3082/api/cart/budget/:refnum
        await Axios.get(`/cart/budget/${user.refnum}`)
            .then(function (response) {
                if (response && response.data?.data?.budgets) {
                    setAvailableBudgets(response.data?.data.budgets);
                    return response.data?.data.budgets;
                }
                else {
                    setAvailableBudgets([]);
                    return false;
                }
            })
            .catch(function (error) {
                setAvailableBudgets([]);
                return false;
            });
    }

    const loadDetails = () =>{
        AuthVerify.getCartDeatils(true).then((data) => {
            setCartDetails(data)
            if (data.carth?.promocode) {
                setPromoCodeApplied(true);
                setPromoCode(data.carth?.promocode);
            }
            setAllowPartialCheckbox(!data.carth.allowpartial);
        });
        getAvailableBudgets();
        getYouMayInterestedProducts();
    }

    useEffect(async () => {
        // GetCartDetails
        loadDetails();
    }, [])

    useEffect(async () => {
        if (availableBudgets.length == 1) {
            loadBudget(availableBudgets[0].budgetnum);
        }
    }, [availableBudgets])

    const defaultValue = {
        matnum: '',
        name: '',
        designation: '',
        department: '',
        deskNumber: '',
        extension: '',
        handphone: '',
        unitNumber: '',
    };

    const [initialValue, setInitialValue] = useState(defaultValue);

    const handleCustomize = (matnum) => {
        var session = AuthVerify.getUser();
        if (!session) window.location.href = '/';
        var templateData = cartDetails.items.find(item => item.matnum == matnum).templatedata;
        console.log(templateData);
        setTemplateData(templateData)

        var existingValue = null
        for (let i = 0; i < templateData.length; i++) {
            existingValue = { ...existingValue, matnum: matnum, [templateData[i].tempdesc]: templateData[i].customvalue }
        }
        if (existingValue) {
            setInitialValue(existingValue);
        } else {
            defaultValue.matnum = matnum;
            setInitialValue(defaultValue);
        }

        handleShow();
    }

    const handlePreview = async (item) => {
        var user = AuthVerify.getUser();
        await Axios.get(`cart/preview/${user.refnum}/${item.uuid}`)
            .then(function (response) {
                if (response && response.data?.success) {
                    var pdfdata = response.data.data;
                    var binary_string = atob(pdfdata);
                    var len = binary_string.length;
                    var bytes = new Uint8Array(len);
                    for (var i = 0; i < len; i++) {
                        bytes[i] = binary_string.charCodeAt(i);
                    }
                    const file = new Blob([bytes], { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    console.log(fileURL)
                    window.open(fileURL);

                }
            })
    }

    const submitFormHandler = (values) => {
        var temp = [];
        templateData.map(item => {
            temp.push({...item, customvalue: values[item.tempdesc]})
        })
        var templatedata = {
            values: values,          
            templatedata: temp
        };
        var session = AuthVerify.getUser();
        if (!session) window.location.href = '/';
        if (!session.items) {
            session.items = {};
        }
        session.items[`${values.matnum}`] = templatedata;
        updateCartItems(null, cartDetails.items.find(item => item.matnum == values.matnum), 0, null, true, temp)
        AuthVerify.setSession(session);
        toast.success('Product updated successfully.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
            transition: Slide,
        });
        handleClose();
    }
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const loadBudget = async (budgetnum) => {
        // const session = AuthVerify.getUser();
        // if(!session)window.location.href = '/';
        // if(budgetnum)session.budgetnum=budgetnum;
        setSelectedBudget(budgetnum);
        let data = availableBudgets.filter(x => x.budgetnum == budgetnum)[0];
        setLoadBudgetData(data);
        // await AuthVerify.setSession(session);
    }

    const productDetails = useRef();
    const [altProductModel, setAltProductModel] = useState(false);
    const showAlternatives = async (matnum) => {
        // matnum="P10-1102-0029"
        await Axios.get("product/productdetails/" + matnum)
            .then(function (response) {
                if (response && response.data && response.data.alternatives) {
                    productDetails.current = response.data;
                    setAltProductModel(true);
                }
                else {
                    toast.warning('No Alternative Products Found !', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 4000,
                        transition: Slide,
                    });
                }
            })
            .catch(function (error) {
                toast.error('No Alternative Products Found !', {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 4000,
                    transition: Slide,
                });
            });
    }

    const [selectedProduct, setSelectedProduct] = useState({});
    const [showQohModal, setShowQohModal] = useState(false);
    const showQoh = (item) => {
        setSelectedProduct(item);
        setShowQohModal(true);
    }

    const refreshBudget = async (budgetnum) => {
        await getAvailableBudgets().then(result => {
            if (result) {
                let data = result.filter(x => x.budgetnum == budgetnum)[0];
                setLoadBudgetData(data);
            }
        })
    }

    const applyPromoCodeValues = (response) => {
        let oldCartDetails = cartDetails;
        setCartDetails([]);
        oldCartDetails.items = response.data.data.items;
        oldCartDetails.carth.promocode = response.data.data.summary.promocode;
        oldCartDetails.carth.discamt = response.data.data.summary.discamt;
        oldCartDetails.carth.gstamt = response.data.data.summary.gstamt;
        oldCartDetails.carth.shippingamt = response.data.data.summary.shippingamt;
        oldCartDetails.carth.subamt = response.data.data.summary.subamt;
        oldCartDetails.carth.totalamt = response.data.data.summary.totalamt;
        setCartDetails(oldCartDetails);
    }

    const applyPromoCode = async (status) => {
        var user = AuthVerify.getUser();
        if (!user) window.location.href = '/';
        // ApplyPromoCodeAPI
        // api/cart/voucher/:refnum
        let promoCodeText = status ? promoCode : '';
        let data = {
            voucher: promoCodeText
        };
        await Axios.post(`/cart/voucher/${user.refnum}`, data)
            .then(function (response) {
                if (response && response.data?.success) {
                    setPromoCodeApplied(status);
                    setPromoCode(promoCodeText);
                    applyPromoCodeValues(response);
                    toast.success(`Promo code ${status ? 'applied' : 'removed'} successfully !`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 4000,
                        transition: Slide,
                    });
                }
                else {
                    toast.error('Invalid promo code !', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 4000,
                        transition: Slide,
                    });
                    setPromoCode('');
                }
            })
            .catch(function (error) {
                setAvailableBudgets([]);
                return false;
            });
    }

    const navigateToNextPage = () => {
        const session = AuthVerify.getUser();
        session.budgetnum = selectedBudget;
        AuthVerify.setSession(session).then(() => {
            navigate('/shopping-cart-info');
        });
    }
    const Invoice = ({nRef}) =>{
        return (
            <div ref={nRef} className="col-sm-12 col-md-12" style={{marginTop:"20px"}}>
                <div className="row col-sm-12 col-md-12" style={{marginBottom:"10px"}}>
                    <div className="col-md-3 col-sm-3">
                        <img src={Logo} style={{ width: "200px", height: "100px", objectFit: "contain" }} />
                    </div>
                    
                    {/* <div className="col-md-6 col-sm-6" style={{textAlign:"right"}} >
                        <img src="http://placehold.it/100X100"/>
                    </div> */}
                </div>
                <div className="col-md-12 col-sm-12" style={{marginBottom:"10px"}}>
                    <h3 style={{marginBottom:"0.2em"}}>PACIFIC BOOKSTORE PTE LTD</h3>
                    <p style={{marginBottom:"0"}}>14 Arumugam Road, #08-01 LTC Building C, Singapore 409959.  Tel: 6559 5271 / 6559 5270   Fax: 6464 0110</p>
                    <p style={{marginBottom:"0"}}>Email:enquiries@pacificbookstores.com   Website:www.pacificeshop.com</p>
                    <p style={{marginBottom:"0"}}>GST Reg.No: 199905993R   Company No: 199905993R</p>
                </div>

                <div className="row col-sm-12 col-md-12" style={{marginBottom:"15px"}}>
                    <div className="col-md-7 col-sm-6">
                        {/* <br/>
                        <div style={{padding:"0", margin:"auto"}}>
                            <h5>WATER PRIMARY SCHOOL</h5>
                            <h5>70 PUNGGOL</h5>
                            <br/>
                            <br/>
                            <h5>70 PUNGGOL</h5>
                        </div> */}
                        <h4>CUSTOMER DETAILS</h4>
                        <table>
                            <tr>
                                <td>{cartDetails?.carth?.arname}</td>
                            </tr>
                            <tr>
                                <td>{cartDetails?.carth?.billaddr1}</td>
                            </tr>
                            <tr>
                                <td>{cartDetails?.carth?.billaddr2}</td>
                            </tr>
                            <tr>
                                <td>{cartDetails?.carth?.billpostcode}</td>
                            </tr>
                            <tr>
                                <td>{cartDetails?.carth?.billptc}</td>
                            </tr>
                        </table>
                    </div>
                    
                    <div className="col-md-5 col-sm-6" >
                        
                        <h4>QUOTATION</h4>
                        <table>
                            <tr>
                                <td>QUOTE NO</td>
                                <td>&nbsp;&nbsp;</td>
                                <td>:</td>
                                <td>&nbsp;&nbsp;</td>
                                <td>{cartDetails?.carth?.refnum}</td>
                            </tr>
                            <tr>
                                <td>DATE</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td><Moment date={new Date()} format="DD/MM/YYYY"/></td>
                            </tr>
                            <tr>
                                <td>REVISION NO</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td>0</td>
                            </tr>
                            <tr>
                                <td>CURRENCY</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td>SGD</td>
                            </tr>
                            <tr>
                                <td>QUOTE STS</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td>**POSTED**</td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div className="col-sm-12 col-md-12" style={{marginBottom:"20px"}}>
                    <table className='col-md-12'>
                        <thead style={{border:"1px solid black",borderRight:"none",borderLeft:"none"}}>
                            <th>No.</th>
                            <th>DESCRIPTION</th>
                            <th>SKU</th>
                            <th>QTY UOM</th>
                            <th>PRICE</th>
                            <th>AMOUNT</th>
                        </thead>
                        <tbody>
                        {cartDetails?.items && cartDetails?.items.map((item, i) => {
                            return (
                                <tr key={i}>
                                    <td>{i+1}</td>
                                    <td>{item.matname}</td>
                                    <td>{item.matnum}</td>
                                    <td>{item.qty}</td>
                                    <td>{item.uprice}</td>
                                    <td style={{textAlign:"right"}}>{(item.qty * item.uprice).toFixed(2)}</td>
                                </tr>
                            )
                        })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>* END OF ITEMS *</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div className="row col-sm-12 col-md-12" style={{marginBottom:"10px"}}>
                    <div className="col-md-8 col-sm-6">
                        <br/>
                        <br/>
                        <h6>TERM & CONDITIONS</h6>
                        <h6>1. QUOTATION VALID FOR 7 DAYS</h6>
                        <h6>2. ITEMS ARE NON-RETURNABLE</h6>
                        <h6>3. 30 DAYS CREDIT TERMS</h6>
                    </div>
                    
                    <div className="col-md-4 col-sm-6" >
                        <table>
                            <tr>
                                <td>TOTAL</td>
                                <td>&nbsp;&nbsp;</td>
                                <td>:</td>
                                <td>&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                <td style={{textAlign:"right"}}>{(cartDetails?.carth?.grossamt ?? 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>DISCOUNT</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td style={{textAlign:"right"}}>{(cartDetails?.carth?.discamt ?? 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>SHIPPING AMOUNT</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td style={{textAlign:"right"}}>{(cartDetails?.carth?.shippingamt ?? 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>GST</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td style={{textAlign:"right"}}>{(cartDetails?.carth?.gstamt ?? 0).toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>GRAND TOTAL</td>
                                <td></td>
                                <td>:</td>
                                <td></td>
                                <td style={{textAlign:"right"}}>{(cartDetails?.carth?.totalamt ?? 0).toFixed(2)}</td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div className="col-sm-8 col-md-6" style={{marginBottom:"10px"}}>
                    <br/>
                    <h5>CUSTOMER SIGNATURE & ACKNOWLEDGEMENT</h5>
                    <br/>
                    <br/>
                    <hr/>
                    <h6 style={{marginBottom:"10px"}}>Name :</h6>
                    <h6>THIS IS COMPUTER GENERATED, NO SIGNATURE IS REQUIRED.</h6>
                </div>
            </div>
        )
    }

    const RenderPart = ({nRef,hide}) =>{
        return (<div className="col-main" ref={nRef}>
                    <div className="shopping-cart-inner">
                        {!hide && cartDetails?.carth?.shippingamt < 1 &&
                            <>
                                {cartDetails.carth?.shipdeldatedisplay && cartDetails.carth.shipdeldatemessage.length > 0 ?
                                    <div className="heading-counter warning text-center">
                                        <i className="fa fa-truck"></i>
                                        <span>
                                            <span>
                                                {cartDetails.carth.shipdeldatemessage}.
                                            </span>
                                        </span>
                                    </div>
                                    :
                                    <>
                                        {cartDetails?.carth?.shippingamt < 1 &&
                                            <div className="heading-counter warning text-center">
                                                <i className="fa fa-truck"></i>
                                                <span> Your cart subtotal is eligible for <strong>free shipping</strong>.</span>
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        }
                        
                        {hide ?
                            <div className="text-center" style={{padding:"15px 0",fontSize:"20px"}}>
                                <span>Quotation</span>
                            </div>
                            :
                            <>
                            {cartDetails?.carth?.importdisplay &&
                            <div md={12} style={{ padding: "5px 0px 10px 0px" }}>
                                <CsvDownloadButton delimiter={","} data={mockData.current} style={{float:"right", textDecoration:"none", fontWeight:"bold", background:"none", color:"#1890ff"}} filename="Order Template.csv">Download CSV Template</CsvDownloadButton>
            
                                <button style={{float:"right", textDecoration:"none", fontWeight:"bold", background:"none", color:"#1890ff"}} onClick={()=>fileInputRef.current.click()}>Import CSV</button>
                                <input accept=".xls,.xlsx,.csv" type="file" onChange={(e) => handleFile(e.target.files[0])} ref={fileInputRef} style={{ display: 'none' }} />
                            </div>
                            }
                            <br />
                            </>
                        }
                        <div className="order-detail-content">
                            <Table responsive className="osya table-bordered jtv-cart-summary">
                                <thead>
                                    <tr>
                                        {/* <th>
                                        <small style={{ color: "#000", fontWeight: '700', textTransform: 'uppercase' }}>
                                            Allow<br />Partial<br />Delivery
                                        </small>
                                    </th> */}
                                        <th className="cart_product">Product</th>
                                        <th>Description</th>
                                        <th>Availability</th>
                                        <th>Unit price</th>
                                        <th>Qty</th>
                                        <th>Total</th>
                                        <th className="action"><i className="fa fa-trash-o" style={{ cursor: "pointer", color: "red" }} onClick={(e) => deleteCartItems(e, false)}></i></th>
                                    </tr>
                                </thead>
                                {
                                    cartDetails && cartDetails.items ?
                                        <>
                                            <tbody>
                                                {cartDetails?.items.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            {/* <td className="cart_avail">
                                                <small><input type="checkbox" name="Material" value="Beaded" /></small>
                                            </td> */}
                                                            <td className="cart_product">
                                                                {hide ?
                                                                    <img src={AuthVerify.getImageLink(item?.imageurl)} alt="Product" />
                                                                    :
                                                                    <Link to={"/product-detail?matnum=" + item?.matnum}>
                                                                    <img src={AuthVerify.getImageLink(item?.imageurl)} alt="Product" /></Link>
                                                                }
                                                            </td>
                                                            <td className="cart_description">
                                                                <p className="product-name">{hide ?<>{item.matname}</>:<Link to={"/product-detail?matnum=" + item?.matnum}> {item.matname} </Link>}</p>
                                                                <small className="cart_ref">SKU No.: {item.matnum}</small><br />
                                                                <small className="cart_ref">Item Price : S${item.uprice}</small><br />
                                                                {item.template === 'Y' && <><small className="cart_ref"><button style={{ float: "left", padding: "3px 5px", marginTop: "5px" }} className="button btn-proceed-checkout" title="Customize" type="button" onClick={() => handleCustomize(item?.matnum)}>Customize</button></small></>}
                                                                {item.template === 'Y' && <><small className="cart_ref"><button style={{ float: "left", padding: "3px 5px", marginTop: "5px" }} className="button btn-proceed-checkout" title="Preview" type="button" onClick={() => handlePreview(item)}>Preview</button></small><br /></>}
                                                            </td>
                                                            {
                                                                item.availability == 'N' ?
                                                                    <td className="cart_avail"><span className="label label-primary">Partial</span>
                                                                        <br />
                                                                        <small className="tooltips">
                                                                            <button onClick={() => showQoh(item)} title="Check Inventory" style={{ color: "#337ab7" }}>Check Inventory</button>
                                                                            <span className="tooltipstext" > Based on Order Qty, the requested item may be delivered in multiple trips</span>
                                                                        </small>
                                                                        <br />
                                                                        <small className="tooltips"><button onClick={() => showAlternatives(item?.matnum)} title="See Alternative" style={{
                                                                            color: "#337ab7"
                                                                        }}>See Alternative</button>

                                                                        </small>
                                                                    </td>
                                                                    :
                                                                    <td className="cart_avail"><span className="label label-success">In stock</span></td>
                                                            }
                                                            <td className="price"><span>S${item.uprice}</span></td>
                                                            <td className="qty">
                                                                <input className="form-control input-sm" type="text" defaultValue={item.qty} onBlur={(e) => updateCartItems(e, item, e.target.value, true)} />
                                                                {item.qty > 1 && !hide && <Link to="/shopping-cart" onClick={(e) => updateCartItems(e, item, -1)}><i className="fa fa-minus"></i></Link>}
                                                                { hide ? <></>:<Link to="/shopping-cart" onClick={(e) => updateCartItems(e, item, +1)}><i className="fa fa-plus"></i></Link>} </td>
                                                            <td className="price"><span>S${(item.qty * item.uprice).toFixed(2)}</span></td>
                                                            <td className="action">{hide ? <></>:<Link to="/shopping-cart" onClick={(e) => deleteCartItems(e, item)}>Delete item</Link>}</td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                                <tr>
                                                    <td colSpan="3" rowSpan="5">
                                                        <div className="input-group mb-3" style={{
                                                            display: "flex", width: "80%"
                                                        }}>
                                                            <input type="text" id="coupon" name="coupon" title="coupon" className="input form-control"
                                                                placeholder="Promo Code Here"
                                                                value={promoCode}
                                                                readOnly={promoCodeApplied}
                                                                onChange={(e) => setPromoCode(e.target.value)}
                                                                style={{
                                                                    marginTop: "0px",
                                                                    marginRight: "0px",
                                                                    padding: "0px"
                                                                }} />
                                                            <div className="input-group-append">
                                                                {promoCodeApplied ?
                                                                    <button className="btn btn-outline-secondary" type="button"
                                                                        onClick={() => applyPromoCode(false)}
                                                                        style={{
                                                                            borderRadius: "0 3px 3px 0",
                                                                            color: "#fff",
                                                                            background: "#f07c2a",
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "0.5px",
                                                                            fontWeight: "600"
                                                                        }}>
                                                                        Remove</button>
                                                                    :
                                                                    <button className="btn btn-outline-secondary" type="button"
                                                                        onClick={() => applyPromoCode(true)}
                                                                        style={{
                                                                            borderRadius: "0 3px 3px 0",
                                                                            color: "#fff",
                                                                            background: "#f07c2a",
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "0.5px",
                                                                            fontWeight: "600"
                                                                        }}>
                                                                        Apply</button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td colSpan="3">Subtotal</td>
                                                    <td colSpan="2">S${(cartDetails?.carth?.grossamt ?? 0).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>Discount</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.discamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>Shipping Amount</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.shippingamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>GST</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.gstamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>Grand Total</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.totalamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                            </tbody>
                                        </>
                                        :
                                        <>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={8} style={{ textAlign: "center" }}>
                                                        No Product Added  !
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </>
                                }
                            </Table>
                            {userDetails && userDetails.role === 'Corporate' &&
                                <Row>
                                    <Col xs={12} sm={6} style={{ textAlign: "center" }}>
                                        {/* {!hide &&
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={allowPartialCheckbox}
                                                onChange={() => setAllowPartialCheckbox(!allowPartialCheckbox)}
                                            />
                                            Allow partial delivery
                                        </label>} */}
                                    </Col>
                                    {cartDetails.carth?.budgetdisplay && <>
                                        <Col xs={12} sm={6}>
                                            <div className="recent-orders">
                                                <div className="title-buttons"><strong>Budget</strong>
                                                    <div className="dropdown block-company-wrapper hidden-xs" style={{ paddingRight: "20px" }}>
                                                        <select style={{ border: 'none', padding: '0', color: 'blue' }} onChange={(e) => loadBudget(e.target.value)}>
                                                            {availableBudgets && availableBudgets.length > 1 && <option style={{ textAlign: 'center', padding: "5px", cursor: "pointer", color: 'blue' }} value={0} disabled selected>Select Budget</option>}
                                                            {availableBudgets && availableBudgets.length > 0 ? availableBudgets.map((item, index) => {
                                                                return (
                                                                    <option key={index} style={{ textAlign: 'center', padding: "5px", cursor: "pointer" }} value={item.budgetnum}>{item.budgetdesc} </option>
                                                                )
                                                            })
                                                                :
                                                                <option style={{ textAlign: 'center', padding: "5px", cursor: "pointer" }} disabled={true} selected={true}>No Budget Found</option>
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="data-table" id="my-orders-table">
                                                    <thead>
                                                        <tr className="first last">
                                                            <th></th>
                                                            <th>Total Amount</th>
                                                            <th>Approved Amount</th>
                                                            <th>Pending Amount</th>
                                                            <th>Current Order Amount</th>
                                                            <th>Balance Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr className="first odd">
                                                            <td>Amount:</td>
                                                            <td>{loadBudgetData.totalamt ?? 0}</td>
                                                            <td>{loadBudgetData.approvedamt ?? 0}</td>
                                                            <td>{loadBudgetData.pendingamt ?? 0}</td>
                                                            <td>{loadBudgetData.currentorderamt ?? 0}</td>
                                                            <td>{loadBudgetData.balanceamt ?? 0}</td>
                                                            <td style={{ padding: "0", border: "none" }}><button type="button" onClick={() => refreshBudget(selectedBudget)}><span><i className="fa fa-refresh"></i></span></button></td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </>}
                                </Row>
                            }
                        </div>
                    </div>
                </div>)
    }

    return (
        <Container className="main">
            <div>
                {/* <RenderPart/> */}
                <div className="col-main">
                    <div className="shopping-cart-inner">
                        {cartDetails?.carth?.shippingamt < 1 &&
                            <>
                                {cartDetails.carth?.shipdeldatedisplay && cartDetails.carth.shipdeldatemessage.length > 0 ?
                                    <div className="heading-counter warning text-center">
                                        <i className="fa fa-truck"></i>
                                        <span>
                                            <span>
                                                {cartDetails.carth.shipdeldatemessage}.
                                            </span>
                                        </span>
                                    </div>
                                    :
                                    <>
                                        {cartDetails?.carth?.shippingamt < 1 &&
                                            <div className="heading-counter warning text-center">
                                                <i className="fa fa-truck"></i>
                                                <span> Your cart subtotal is eligible for <strong>free shipping</strong>.</span>
                                            </div>
                                        }
                                    </>
                                }
                            </>
                        }
                        {cartDetails?.carth?.importdisplay &&
                            <div md={12} style={{ padding: "5px 0px 10px 0px" }}>
                                <CsvDownloadButton delimiter={","} data={mockData.current} style={{ float: "right", textDecoration: "none", fontWeight: "bold", background: "none", color: "#1890ff" }} filename="Order Template.csv">Download CSV Template</CsvDownloadButton>

                                <button style={{ float: "right", textDecoration: "none", fontWeight: "bold", background: "none", color: "#1890ff" }} onClick={() => fileInputRef.current.click()}>Import CSV</button>
                                <input accept=".xls,.xlsx,.csv" type="file" onChange={(e) => handleFile(e.target.files[0])} ref={fileInputRef} style={{ display: 'none' }} />
                            </div>
                        }
                        <br />
                        <div className="order-detail-content">
                            <Table responsive className="osya table-bordered jtv-cart-summary">
                                <thead>
                                    <tr>
                                        {/* <th>
                                        <small style={{ color: "#000", fontWeight: '700', textTransform: 'uppercase' }}>
                                            Allow<br />Partial<br />Delivery
                                        </small>
                                    </th> */}
                                        <th className="cart_product">Product</th>
                                        <th>Description</th>
                                        <th>Availability</th>
                                        <th>Unit price</th>
                                        <th>Qty</th>
                                        <th>Total</th>
                                        <th className="action"><i className="fa fa-trash-o" style={{ cursor: "pointer", color: "red" }} onClick={(e) => deleteCartItems(e, false)}></i></th>
                                    </tr>
                                </thead>
                                {
                                    cartDetails && cartDetails.items ?
                                        <>
                                            <tbody>
                                                {cartDetails?.items.map((item, i) => {
                                                    return (
                                                        <tr key={i}>
                                                            {/* <td className="cart_avail">
                                                <small><input type="checkbox" name="Material" value="Beaded" /></small>
                                            </td> */}
                                                            <td className="cart_product">

                                                                <Link to={"/product-detail?matnum=" + item?.matnum}>
                                                                    <img src={AuthVerify.getImageLink(item?.imageurl)} alt="Product" /></Link>

                                                            </td>
                                                            <td className="cart_description">
                                                                <p className="product-name"><Link to={"/product-detail?matnum=" + item?.matnum}> {item.matname} </Link></p>
                                                                <small className="cart_ref">SKU No.: {item.matnum}</small><br />
                                                                <small className="cart_ref">Item Price : S${item.uprice}</small><br />
                                                                {item.template === 'Y' && <><small className="cart_ref"><button style={{ float: "left", padding: "3px 5px", marginTop: "5px" }} className="button btn-proceed-checkout" title="Customize" type="button" onClick={() => handleCustomize(item?.matnum)}>Customize</button></small></>}
                                                                {item.template === 'Y' && <><small className="cart_ref"><button style={{ float: "left", padding: "3px 5px", marginTop: "5px" }} className="button btn-proceed-checkout" title="Preview" type="button" onClick={() => handlePreview(item)}>Preview</button></small><br /></>}
                                                            </td>
                                                            {
                                                                item.availability == 'N' ?
                                                                    <td className="cart_avail"><span className="label label-primary">Partial</span>
                                                                        <br />
                                                                        <small className="tooltips">
                                                                            <button onClick={() => showQoh(item)} title="Check Inventory" style={{ color: "#337ab7" }}>Check Inventory</button>
                                                                            <span className="tooltipstext" > Based on Order Qty, the requested item may be delivered in multiple trips</span>
                                                                        </small>
                                                                        <br />
                                                                        <small className="tooltips"><button onClick={() => showAlternatives(item?.matnum)} title="See Alternative" style={{
                                                                            color: "#337ab7"
                                                                        }}>See Alternative</button>

                                                                        </small>
                                                                    </td>
                                                                    :
                                                                    <td className="cart_avail"><span className="label label-success">In stock</span></td>
                                                            }
                                                            <td className="price"><span>S${item.uprice}</span></td>
                                                            <td className="qty">
                                                                <input className="form-control input-sm" type="text" defaultValue={item.qty} onBlur={(e) => updateCartItems(e, item, e.target.value, true)} />
                                                                {item.qty > 1 && <Link to="/shopping-cart" onClick={(e) => updateCartItems(e, item, -1)}><i className="fa fa-minus"></i></Link>}
                                                                <Link to="/shopping-cart" onClick={(e) => updateCartItems(e, item, +1)}><i className="fa fa-plus"></i></Link> </td>
                                                            <td className="price"><span>S${(item.qty * item.uprice).toFixed(2)}</span></td>
                                                            <td className="action"><Link to="/shopping-cart" onClick={(e) => deleteCartItems(e, item)}>Delete item</Link></td>
                                                        </tr>
                                                    )
                                                })
                                                }
                                                <tr>
                                                    <td colSpan="3" rowSpan="5">
                                                        <div className="input-group mb-3" style={{
                                                            display: "flex", width: "80%"
                                                        }}>
                                                            <input type="text" id="coupon" name="coupon" title="coupon" className="input form-control"
                                                                placeholder="Promo Code Here"
                                                                value={promoCode}
                                                                readOnly={promoCodeApplied}
                                                                onChange={(e) => setPromoCode(e.target.value)}
                                                                style={{
                                                                    marginTop: "0px",
                                                                    marginRight: "0px",
                                                                    padding: "0px"
                                                                }} />
                                                            <div className="input-group-append">
                                                                {promoCodeApplied ?
                                                                    <button className="btn btn-outline-secondary" type="button"
                                                                        onClick={() => applyPromoCode(false)}
                                                                        style={{
                                                                            borderRadius: "0 3px 3px 0",
                                                                            color: "#fff",
                                                                            background: "#f07c2a",
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "0.5px",
                                                                            fontWeight: "600"
                                                                        }}>
                                                                        Remove</button>
                                                                    :
                                                                    <button className="btn btn-outline-secondary" type="button"
                                                                        onClick={() => applyPromoCode(true)}
                                                                        style={{
                                                                            borderRadius: "0 3px 3px 0",
                                                                            color: "#fff",
                                                                            background: "#f07c2a",
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "0.5px",
                                                                            fontWeight: "600"
                                                                        }}>
                                                                        Apply</button>
                                                                }
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td colSpan="3">Subtotal</td>
                                                    <td colSpan="2">S${(cartDetails?.carth?.grossamt ?? 0).toFixed(2)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>Discount</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.discamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>Shipping Amount</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.shippingamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>GST</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.gstamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="3"><strong>Grand Total</strong></td>
                                                    <td colSpan="2"><strong>S${(cartDetails?.carth?.totalamt ?? 0).toFixed(2)}</strong></td>
                                                </tr>
                                            </tbody>
                                        </>
                                        :
                                        <>
                                            <tbody>
                                                <tr>
                                                    <td colSpan={8} style={{ textAlign: "center" }}>
                                                        No Product Added  !
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </>
                                }
                            </Table>
                            {userDetails && userDetails.role === 'Corporate' &&
                                <Row>
                                    <Col xs={12} sm={6} style={{ textAlign: "center" }}>
                                        {/* {!hide &&
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={allowPartialCheckbox}
                                                onChange={() => setAllowPartialCheckbox(!allowPartialCheckbox)}
                                            />
                                            Allow partial delivery
                                        </label>} */}
                                    </Col>
                                    {cartDetails.carth?.budgetdisplay && <>
                                        <Col xs={12} sm={6}>
                                            <div className="recent-orders">
                                                <div className="title-buttons"><strong>Budget</strong>
                                                    <div className="dropdown block-company-wrapper hidden-xs" style={{ paddingRight: "20px" }}>
                                                        <select style={{ border: 'none', padding: '0', color: 'blue' }} onChange={(e) => loadBudget(e.target.value)}>
                                                            {availableBudgets && availableBudgets.length > 1 && <option style={{ textAlign: 'center', padding: "5px", cursor: "pointer", color: 'blue' }} value={0} disabled selected>Select Budget</option>}
                                                            {availableBudgets && availableBudgets.length > 0 ? availableBudgets.map((item, index) => {
                                                                return (
                                                                    <option key={index} style={{ textAlign: 'center', padding: "5px", cursor: "pointer" }} value={item.budgetnum}>{item.budgetdesc} </option>
                                                                )
                                                            })
                                                                :
                                                                <option style={{ textAlign: 'center', padding: "5px", cursor: "pointer" }} disabled={true} selected={true}>No Budget Found</option>
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="data-table" id="my-orders-table">
                                                    <thead>
                                                        <tr className="first last">
                                                            <th></th>
                                                            <th>Total Amount</th>
                                                            <th>Approved Amount</th>
                                                            <th>Pending Amount</th>
                                                            <th>Current Order Amount</th>
                                                            <th>Balance Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr className="first odd">
                                                            <td>Amount:</td>
                                                            <td>{loadBudgetData.totalamt ?? 0}</td>
                                                            <td>{loadBudgetData.approvedamt ?? 0}</td>
                                                            <td>{loadBudgetData.pendingamt ?? 0}</td>
                                                            <td>{loadBudgetData.currentorderamt ?? 0}</td>
                                                            <td>{loadBudgetData.balanceamt ?? 0}</td>
                                                            <td style={{ padding: "0", border: "none" }}><button type="button" onClick={() => refreshBudget(selectedBudget)}><span><i className="fa fa-refresh"></i></span></button></td>

                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Col>
                                    </>}
                                </Row>
                            }
                        </div>
                    </div>
                </div>
                <div style={{display:'none'}}><Invoice nRef={componentRef}/></div>
                <hr />
                <div className="text-right text-danger">
                    <i className="fa fa-warning"></i>
                    <span>Stock On Hand may vary upon confirmation</span>
                </div>

                <div className="cart_navigation">
                    <Link to='/' style={{ padding: '0px', border: 'none' }}>
                        <button className="button continue-shopping" title="Continue shopping" type="button">
                            <span>Continue shopping</span></button>
                    </Link>
                    {cartDetails?.carth?.adhocbtndisplay && <button className="button continue-shopping" title="Add ad-hoc item" type="button" onClick={(e)=>setShowAdhocModal(true)}><span>Ad-hoc Item</span></button>}
                    <button className="button continue-shopping" title="Empty cart" type="button" onClick={(e) => deleteCartItems(e, false)}><span>Empty Cart</span></button>
                    <button className="button continue-shopping" title="Save as draft" type="button" style={{ margin: '0 3px' }} onClick={(e) => saveAsDraft(e)}>
                        <span>Save to Draft Order</span>
                    </button>
                    <button className="button continue-shopping" title="Save as template" type="button" style={{ margin: '0 3px' }} onClick={(e) => setSaveAsTemplateModal(true)}>
                        <span>Save as Template</span>
                    </button>
                    <div style={{ padding: '0px', border: 'none', float: 'right' }}>
                        <button onClick={() => { navigateToNextPage() }} className="button btn-proceed-checkout" title="Proceed to Checkout" type="button">
                            <span>Proceed</span>
                        </button>
                        <button onClick={handlePrint} className="button btn-proceed-checkout" type="button">
                            <span>Print</span>
                        </button>
                    </div>
                </div>
            </div>
            {/* <FeaturedProducts firstprop={'you may be interested'} products={interestedProducts} /> */}
            <div className="content-page">
                <Container>
                    {/* <!-- Product Tabs--> */}
                    <div className="category-product">
                        {interestedProducts && interestedProducts.length > 0 &&
                            <Tab.Container id="left-tabs-example" defaultActiveKey={interestedProducts[0].matgp}>
                                <div className="navbar nav-menu">
                                    <div className="navbar-collapse">
                                        <div className="jtv-title">
                                            <h2>you may be interested</h2>
                                        </div>
                                    </div>
                                    {/* <!-- /.navbar-collapse --> */}
                                </div>
                                <br />
                                <Tab.Content>
                                    {interestedProducts &&
                                        <DynamicProductList productList={interestedProducts} />
                                    }
                                </Tab.Content>
                            </Tab.Container>
                        }
                    </div>
                </Container>
            </div>
            <Modal show={show} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Customize Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={initialValue}
                        /* validationSchema={Yup.object().shape({
                            name: Yup.string().required("Name name is required"),
                            designation: Yup.string().required("Designation name is required"),
                            department: Yup.string().required("Department name is required"),
                            deskNumber: Yup.string().required("Desk Number name is required"),
                            extension: Yup.string().required("Extension name is required"),
                            handphone: Yup.string().required("Handphone name is required"),
                            unitNumber: Yup.string().required("Unit Number name is required"),

                            // phone: Yup.string().min(8, "Contact number must be of 8 digits").required("Please enter your contact number")
                        })} */
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            setSubmitting(false);
                            submitFormHandler(values);
                        }}
                        enableReinitialize
                    >
                        {(props) => {
                            const {
                                values,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                errors, touched
                            } = props;
                            return (
                                <Form onSubmit={handleSubmit}>
                                    <div className="box-border">
                                        <div className="form-list">
                                            <Row>
                                                {templateData.map(item => {
                                                    return (
                                                        <Col xl={6} sm={6}>
                                                            <InputField
                                                                Name={item.tempdesc}
                                                                id={item.tempdesc}
                                                                Labels={item.tempdesc}
                                                                Type="text"
                                                                value={values[item.tempdesc]}
                                                                onChange={handleChange}
                                                                isInvalid={!!errors[item.tempdesc]}
                                                                className={(errors[item.tempdesc] && touched[item.tempdesc]) ? 'is-invalid' : 'form-control'}
                                                            />
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </div>
                                    </div>
                                    <Row>
                                        <div className="cart_navigation">
                                            <button
                                                className="button btn-proceed-checkout btn-danger"
                                                title="Proceed to Checkout"
                                                type="button"
                                                onClick={handleClose} style={{
                                                    marginRight: "10px",
                                                    padding: "10px"
                                                }}
                                            >
                                                <span>Close</span>
                                            </button>


                                            <button
                                                className="button btn-proceed-checkout"
                                                title="Proceed to Checkout"
                                                type="submit"
                                                style={{
                                                    marginRight: "10px",
                                                    background: "#337ab7",
                                                    border: "0px solid #337ab7",
                                                    padding: "10px"
                                                }}
                                            >
                                                <span>Update</span>
                                            </button>
                                        </div>

                                    </Row>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>

            <Modal show={showQohModal} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setShowQohModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{selectedProduct.matname}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Quantity On Hand : {selectedProduct.qoh} as of {selectedProduct.qohtime ? (new Date(selectedProduct.qohtime)).toLocaleString(undefined, {}) : ''}</p>
                </Modal.Body>
            </Modal>

            <Modal show={altProductModel} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setAltProductModel(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Alternative Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AlternativeProduct data={productDetails.current} />
                </Modal.Body>
            </Modal>

            <Modal show={saveAsTemplateModal} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setSaveAsTemplateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Template Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={{ templateName: '', templateRemarks: '' }}
                        validationSchema={Yup.object().shape({
                            templateName: Yup.string().required("Name is required !"),
                            templateRemarks: Yup.string()
                        })}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            setSubmitting(false);
                            saveAsTemplate(values);
                        }}
                        enableReinitialize
                    >
                        {(props) => {
                            const {
                                values,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                errors, touched
                            } = props;
                            return (
                                <Form onSubmit={handleSubmit}>
                                    <div className="box-border">
                                        <div className="form-list">
                                            <Row>
                                                <Col xl={6} sm={6}>
                                                    <InputField
                                                        Name="templateName"
                                                        id="templateName"
                                                        Labels="Template Name"
                                                        Type="text"
                                                        value={values.templateName}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.templateName}
                                                        className={(errors.templateName && touched.templateName) ? 'is-invalid' : 'form-control'}
                                                    />
                                                </Col>
                                                <Col xl={6} sm={6}>
                                                    <InputField
                                                        Name="templateRemarks"
                                                        id="templateRemarks"
                                                        Labels="Template Remarks"
                                                        Type="text"
                                                        value={values.templateRemarks}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.templateRemarks}
                                                        className={(errors.templateRemarks && touched.templateRemarks) ? 'is-invalid' : 'form-control'}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <Row>
                                        <div className="cart_navigation">
                                            <button
                                                className="button btn-proceed-checkout btn-danger"
                                                title="Proceed to Checkout"
                                                type="button"
                                                onClick={() => setSaveAsTemplateModal(false)}
                                                style={{
                                                    marginRight: "10px",
                                                    padding: "10px"
                                                }}
                                            >
                                                <span>Close</span>
                                            </button>

                                            <button
                                                className="button btn-proceed-checkout"
                                                title="Proceed to Checkout"
                                                type="submit"
                                                style={{
                                                    marginRight: "10px",
                                                    background: "#337ab7",
                                                    border: "0px solid #337ab7",
                                                    padding: "10px"
                                                }}
                                            >
                                                <span>Save As Template</span>
                                            </button>
                                        </div>

                                    </Row>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>

            <Modal show={showAdhocModal} dialogClassName="modal-90w" animation={false} fade={false} style={{ opacity: 1 }} onHide={() => setShowAdhocModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Adhoc Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={{ matname: '', uprice: 0, uom: '' }}
                        validationSchema={Yup.object().shape({
                            matname: Yup.string().required("Product name is required!"),
                            uprice: Yup.number().required('Price is required!'),
                            uom: Yup.string().required('Product UOM is required!')
                        })}
                        onSubmit={(values, { setSubmitting, resetForm }) => {
                            setSubmitting(false);
                            updateAdhocCartItem(values);
                            setShowAdhocModal(false);
                        }}
                        enableReinitialize
                    >
                        {(props) => {
                            const {
                                values,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                                errors, touched
                            } = props;
                            return (
                                <Form onSubmit={handleSubmit}>
                                    <div className="box-border">
                                        <div className="form-list">
                                            <Row>
                                                <Col xl={6} sm={6}>
                                                    <InputField
                                                        Name="matname"
                                                        id="matname"
                                                        Labels="Product Name"
                                                        Type="text"
                                                        value={values.matname}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.matname}
                                                        className={(errors.matname && touched.matname) ? ' is-invalid' : 'form-control'}
                                                    />
                                                </Col>
                                                <Col xl={6} sm={6}>
                                                    <InputField
                                                        Name="uprice"
                                                        id="uprice"
                                                        Labels="Unit Price"
                                                        Type="number"
                                                        value={values.uprice}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.uprice}
                                                        className={(errors.uprice && touched.uprice) ? ' is-invalid' : 'form-control'}
                                                    />
                                                </Col>
                                                <Col xl={6} sm={6}>
                                                    <InputField
                                                        Name="uom"
                                                        id="uom"
                                                        Labels="UOM"
                                                        Type="text"
                                                        value={values.uom}
                                                        onChange={handleChange}
                                                        isInvalid={!!errors.uom}
                                                        className={(errors.uom && touched.uom) ? ' is-invalid' : 'form-control'}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    <Row>
                                        <div className="cart_navigation">
                                            <button
                                                className="button btn-proceed-checkout btn-danger"
                                                title="Proceed to Checkout"
                                                type="button"
                                                onClick={() => setShowAdhocModal(false)}
                                                style={{
                                                    marginRight: "10px",
                                                    padding: "10px"
                                                }}
                                            >
                                                <span>Close</span>
                                            </button>

                                            <button
                                                className="button btn-proceed-checkout"
                                                title="Proceed to Checkout"
                                                type="submit"
                                                style={{
                                                    marginRight: "10px",
                                                    background: "#337ab7",
                                                    border: "0px solid #337ab7",
                                                    padding: "10px"
                                                }}
                                            >
                                                <span>Add To Cart</span>
                                            </button>
                                        </div>

                                    </Row>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>

        </Container >

    )
}

export default ShoppingCart